<template>
    <main class="vagos3" id="contact">

        <div v-if="done" class="bg-black/50 h-screen w-full fixed top-0 left-0 z-50 flex items-center justify-center">
            <div class="text-blue-700 bg-white rounded-xl p-6 w-[95%] max-w-md text-center">
                Votre demande a bien été reçue et sera traitée dans les plus brefs délais.<br><br>
                Pensez à vérifier vos courriers indésirables si vous ne recevez pas de réponse rapidement.
                <br />
                <br />
                <button class="bg-blue-700 text-white px-4 py-2 rounded-full cursor-pointer"
                    @click="closeDone">Fermer</button>
            </div>
        </div>
        <section class="lg:flex items-center justify-center relative pt-[4%]">
            <div class="form1">
                <div class=" w-full pt-[10%] lg:pt-0 h-full lg:flex justify-between items-center">

                    <div class="bg-transparent rounded-lg p-4 w-full mx-auto">



                        <div
                            class="relative z-30 max-w-2xl bg-black/50 text-white w-full py-6 rounded-3xl m-auto px-6  text-center mx-auto">
                            <h1 class="text-white text-2xl adlam mb-6 pt-4">

                                <p>CONTACT</p>
                            </h1>
                            <form class="relative z-50">
                                <div class="form-item">
                                    <label>Votre nom*</label>
                                    <input @input="error.lastname = ''" :disabled="loadingState" required
                                        v-model="form.lastname" id="lastname" type="text" />
                                    <span v-if="error.lastname" class="error">*{{ error.lastname }}</span>
                                </div>
                                <div class="form-item">
                                    <label class="sm:-mt-2">Votre prénom*</label>
                                    <input @input="error.firstname = ''" :disabled="loadingState" required
                                        v-model="form.firstname" id="firstname" type="text" />
                                    <span v-if="error.firstname" class="error">*{{ error.firstname }}</span>
                                </div>
                                <div class="form-item">
                                    <label class="sm:-mt-2">Votre adresse email*</label>
                                    <input @input="error.email = ''" :disabled="loadingState" required
                                        v-model="form.email" class="w-full" id="email" type="email" />
                                    <span v-if="error.email" class="error">*{{ error.email }}</span>
                                </div>
                                <div class="form-item">
                                    <label class="sm:-mt-2">Votre numéro de téléphone*</label>
                                    <input @input="error.phone = ''" :disabled="loadingState" required
                                        v-model="form.phone" class="w-full" id="phone" type="tel" />
                                    <span v-if="error.phone" class="error">*{{ error.email }}</span>
                                </div>
                                <div class="form-item">
                                    <label class="sm:-mt-2">Type de demande*</label>
                                    <select :disabled="loadingState" required id="status" name="contact[statut]"
                                        class="form-control form-control" v-model="form.objet">
                                        <option value="" disabled selected>Choisissez une option</option>

                                        <option>Problème technique lors de ma participation</option>
                                        <option>Je n'arrive pas à télécharger mes preuves d'achat</option>
                                        <option>Le site de l'offre ne fonctionne pas</option>
                                        <option>Demande d'information sur l'offre</option>
                                        <option>
                                            Mon ou mes produit(s) est (sont)-il(s) éligible(s) à l'offre?
                                        </option>
                                        <option>
                                            Demande de suivi concernant l'expédition de ma dotation
                                        </option>
                                        <option>Autre</option>
                                    </select>
                                    <span v-if="error.objet" class="error">*{{ error.objet }}</span>
                                </div>
                                <div class="form-item">
                                    <label class="sm:-mt-2">Objet*</label>
                                    <input @input="error.object = ''" :disabled="loadingState" required
                                        v-model="form.object" id="object" type="text" />
                                    <span v-if="error.object" class="error">*{{ error.object }}</span>
                                </div>
                                <div class="form-item">
                                    <label>Message*</label>
                                    <textarea @input="error.message = ''" id="contact_message" name="message"
                                        required="required" class="form-control form-control h-36"
                                        v-model="form.message"></textarea>
                                    <span v-if="error.message" class="error">*{{ error.message }}</span>
                                </div>



                                <div class="text-sm text-left mt-4">

                                    <b>Cliquez sur les liens ci-dessous et lisez attentivement leur contenu.</b><br>
                                    En cochant les cases, vous reconnaissez avoir lu et accepté les conditions suivantes
                                    :<br><br>
                                    <label class="flex items-start">
                                        <input type="checkbox" id="conditions" name="conditions" v-model="confirm"
                                            required class="mr-2"><span class="text-sm">J’accepte que mes données soient
                                            recueillies et conservées pour gérer ma demande*</span>
                                    </label>
                                </div>






                                <div class="text-xs italic text-left mt-2">
                                    *Champs obligatoires
                                </div>


                            </form>
                            <div class="w-full text-center mb-6">
                                <p v-if="!loadingState">
                                    <a @click.prevent="getResult" class="button2 ">ENVOYER</a>
                                </p>
                                <a v-if="loadingState" class="button2">
                                    Chargement...
                                </a>
                            </div>
                            <p class="text-xs text-left md:mt-[4%]">Petit Navire traite les données recueillies sur la
                                base de votre consentement pour gérer votre demande. Pour en savoir plus sur la gestion
                                de vos données personnelles et pour exercer vos droits, reportez-vous à la <a
                                    href="https://petitnavire.fr/fr/mentions-legales#charte_de_confidentialite"
                                    target="_blank" class="text-white underline font-bold">politique de
                                    confidentialité</a>.</p>
                        </div>

                    </div>


                </div>
            </div>
        </section>
    </main>
</template>




<script>
import axios from "axios";



export default {
    data: function () {
        return {
            error: {},
            confirm: false,
            open: false,
            loadingState: false,
            required_field: ["lastname", "firstname", "object", "email", "message"],
            operationId: "6904b53d310c505cd7f8a31f",
            idgame: "2025-Agence-TMS-463",
            subid: "",
            uid: "",
            done: false,
            form: {
                object: "",
                operation: undefined,
                youare: "Particulier",
                civilite: "MR",
                addr: {},
            },
        };
    },
    async mounted() {
        try {
            this.operationId = "6904b53d310c505cd7f8a31f";
            this.idgame = "2025-Agence-TMS-463";
            this.subid = sessionStorage.getItem("subid") || null;
            this.uid = sessionStorage.getItem("subid") || null;

            this.scrollToTop();

            if (this.subid != null && this.uid != null) {
                let { data: submission } = await axios.get(
                    `${process.env.VUE_APP_ROOT_API}/api/v2/submissions/${this.subid}?uid=${this.uid}`
                );

                if (submission) {
                    this.form = {
                        subid: this.subid,
                        operationId: this.operationId,
                        lastname: submission.last_name,
                        firstname: submission.first_name,
                        email: submission.email,
                        email_confirmation: submission.email,
                    };
                }
            }
        } catch (e) {
            console.log(e);
        }
    },
    methods: {
        closeDone() {
            this.done = false;
            this.form = {};
            this.$router.push("/");
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        isRequired(value) {
            return value ? true : "Ce champ est requis";
        },
        getResult() {
            try {

                if (!this.confirm) {
                    alert("Vous devez accepter les conditions");
                    return;
                }
                this.loadingState = true;
                let error = 0;

                for (let key of this.required_field) {
                    if (!this.form[key] || this.form[key] == "") {
                        this.error[key] = "Ce champ est requis";
                        error++;
                    }
                }
                if (error > 0) {
                    this.loadingState = false;
                    return;
                }

                let id = sessionStorage.getItem("_id");

                if (id == null) id = "n/a";

                if (error === 0) {
                    var formDatas = {
                        civilite: "Mr",
                        operationId: "6904b53d310c505cd7f8a31f",
                        nom: this.form.lastname,
                        prenom: this.form.firstname,
                        email: this.form.email,
                        subid: this.subid,
                        society: this.form.society,
                        demande: this.idgame,
                        objet: this.form.objet,
                        message: `${this.form.message}`,
                        idgame: "2025-Agence-TMS-463",
                        type: "plateforme",
                        phone: this.form.phone,
                    };
                    axios
                        .post(
                            `https://api-gabarit.promo.dev/api/operations-custom/promodev-send-contact/sendmail`,
                            formDatas
                        )
                        .then(() => {
                            this.loadingState = false;
                            this.dialogState = true;
                            this.form = {};
                            this.done = true;
                        });
                } else {
                    this.loadingState = false;
                }
            } catch (e) {
                console.log(e);
                this.loadingState = false;
            }
        },
    },
};
</script>
<style scoped>
.button2 {
    @apply bg-white text-[#132650] h-12 flex justify-center items-center text-4xl rounded-full;
    font-family: "Veneer Two";
    margin: 0 auto !important;
    padding: 0 !important;
    width: 200px;
    padding-top: 10px !important;

}

.form1 {
    background-image: none;

}

.vagos3 {
    background-color: #0d2651;
    background-image: url("@/assets/images/fond-perdu.svg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

h1 {
    font-family: "Veneer Two";
    @apply text-4xl;
}

#contact input,
#contact select,
#contact textarea {
    @apply text-[#000];
}

#contact .error {
    @apply text-red-700 text-left block w-full py-1;
    color: #fff;
}
</style>